// Styles for MbopOffers go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledMbopOffers = styled.div`
  .card-layered {
    border-radius: unset !important;
    box-shadow: unset;
    .t-overline-overlay {
      font-weight: 700;
    }
  }

  .right-arrow,
  .left-arrow {
    width: fit-content;
  }

  .m-badge-overlay-merch {
    color: ${baseVariables.color['base20']};
    background-color: ${baseVariables.color['base10']} !important;
    padding: ${toRem(8)};
  }
`;
